export var appSchema = [
	{
        type: 'group',
        name: 'source',
        label: 'Dataset Source',
        children: [
            {
                type: 'upload',
                name: 'folder',
                label: 'Upload Images',
                description: 'Sample upload field to preview image files, a zip archive of images, or a folder selection in the app modal.',
                selection_mode: 'mixed',
                files_filter: ['.jpg', '.jpeg', '.png', '.bmp', '.webp', '.tif', '.tiff', '.zip', '.JPG', '.JPEG', '.PNG', '.BMP', '.WEBP', '.TIF', '.TIFF', '.ZIP'],
            },
            {
                type: 'bool',
                name: 'image_groups',
                label: 'Create image groups from folder names',
                default: false,
                description: 'If enabled, images will be grouped based on their parent folder names.',
            },
        ],
    },
    {
        type: 'group',
        name: 'destination',
        label: 'Dataset Destination',
        children: [
            {
                type: 'bool',
                name: 'new_dataset',
                label: 'New Dataset',
                default: true,
                description: 'Enable this option to create a new dataset for the imported images. Otherwise, select an existing dataset in EdgeFirst Studio.',
                children: [
                    {
                        type: 'dataset',
                        name: 'dataset_info',
                        label: 'Select Dataset*',
                        required: true,
                        show_on_false: true,
                        enable_annotation_set_selection: true,
                        enable_tags_selection: false,
                        description: 'Select an existing destination dataset for the imported images.',
                    },
                    {
                        type: 'project',
                        name: 'project_id',
                        label: 'Project*',
                        required: true,
                        description: 'Select the project that should own the new dataset.',
                    },
                    {
                        type: 'text',
                        name: 'name',
                        label: 'Dataset Name*',
                        required: true,
                        description: 'Enter the dataset name to create before the import starts.',
                    },
                    {
                        type: 'text',
                        name: 'description',
                        label: 'Dataset Description',
                        is_multi_line: true,
                        description: 'Optional description for the new dataset.',
                    },
                    {
                        type: 'text',
                        name: 'annotation_set_name',
                        label: 'Annotation Set Name',
                        default: 'annotations',
                        description: 'Optional annotation set name to create with the dataset.',
                    },
                ],
            },
        ],
    }
];